<template>
  <div id="app">
    <el-container>
      <!-- 侧边栏菜单 -->
      <el-aside width="200px">
        <el-menu
          default-active="1"
          class="el-menu-vertical-demo"
          @select="handleMenuSelect"
        >
          <el-menu-item index="1">
            <i class="el-icon-user"></i>
            <span slot="title">个人信息</span>
          </el-menu-item>
          <el-menu-item index="2">
            <i class="el-icon-document"></i>
            <span slot="title">我的帖子</span>
          </el-menu-item>
          <el-menu-item index="3">
            <i class="el-icon-goods"></i>
            <span slot="title">我的商品</span>
          </el-menu-item>
          <el-menu-item index="4">
            <i class="el-icon-thumb"></i>
            <span slot="title">我的点赞</span>
          </el-menu-item>
          <el-menu-item index="5">
            <i class="el-icon-star-on"></i>
            <span slot="title">我的收藏</span>
          </el-menu-item>
          <el-menu-item index="6">
            <i class="el-icon-s-comment"></i>
            <span slot="title">我的评论</span>
          </el-menu-item>
          <el-menu-item index="7">
            <i class="el-icon-user-solid"></i>
            <span slot="title">关注/粉丝</span>
          </el-menu-item>
          <el-menu-item index="8">
            <i class="el-icon-chat-dot-round"></i>
            <span slot="title">私信列表</span>
          </el-menu-item>
        </el-menu>
      </el-aside>

      <!-- 主内容区域 -->
      <el-main>
        <!-- 个人信息 -->
        <div v-if="activeMenu === '1'">
          <el-form :model="userInfo" label-width="100px">
            <el-form-item label="头像">
              <div class="avatar-upload-container">
                <el-upload
                  class="avatar-uploader"
                  action="http://www.wjyzlj.cn/pet/file/upload"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :headers="headers"
                >
                  <img
                    v-if="userInfo.headPicture"
                    :src="userInfo.headPicture"
                    class="avatar"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div class="follow-info">
                  <div class="follow-item">
                    <span class="count">{{ userInfo.followCount || 0 }}</span>
                    <span class="label">关注</span>
                  </div>
                  <div class="follow-item">
                    <span class="count">{{ userInfo.fansCount || 0 }}</span>
                    <span class="label">粉丝</span>
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="用户名">
              <el-input v-model="userInfo.username"></el-input>
            </el-form-item>
            <el-form-item label="性别">
              <el-radio-group v-model="userInfo.sex">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="2">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="注册时间">
              <el-date-picker
                v-model="userInfo.createTime"
                type="datetime"
                disabled
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="邮箱">
              <el-input v-model="userInfo.email"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input v-model="userInfo.phone"></el-input>
            </el-form-item>
            <el-form-item label="个人简介">
              <el-input
                type="textarea"
                v-model="userInfo.introduction"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="saveUserInfo">保存</el-button>
              <el-button @click="showChangePasswordDialog">修改密码</el-button>
            </el-form-item>
          </el-form>

          <!-- 修改密码对话框 -->
          <el-dialog
            title="修改密码"
            :visible.sync="passwordDialogVisible"
            width="30%"
          >
            <el-form
              :model="passwordForm"
              :rules="passwordRules"
              ref="passwordForm"
              label-width="100px"
            >
              <el-form-item label="原密码" prop="oldPassword">
                <el-input
                  type="password"
                  v-model="passwordForm.oldPassword"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item label="新密码" prop="newPassword">
                <el-input
                  type="password"
                  v-model="passwordForm.newPassword"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item label="确认密码" prop="confirmPassword">
                <el-input
                  type="password"
                  v-model="passwordForm.confirmPassword"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="passwordDialogVisible = false">取消</el-button>
              <el-button type="primary" @click="changePassword">确定</el-button>
            </span>
          </el-dialog>
        </div>

        <!-- 我的帖子 -->
        <div v-if="activeMenu === '2'">
          <div class="filter-container">
            <el-tabs v-model="postActiveTab" @tab-click="handlePostTabClick">
              <el-tab-pane label="全部" name="all"></el-tab-pane>
              <el-tab-pane label="审核中" name="reviewing"></el-tab-pane>
              <el-tab-pane label="已发布" name="published"></el-tab-pane>
              <el-tab-pane label="未通过" name="rejected"></el-tab-pane>
            </el-tabs>
            <div class="filter-bar">
              <el-date-picker
                v-model="postFilterDate"
                type="date"
                placeholder="选择日期"
                @change="filterPostsByDate"
                style="margin-right: 15px"
              ></el-date-picker>
              <el-button
                type="primary"
                icon="el-icon-refresh"
                @click="refreshPosts"
                >刷新</el-button
              >
            </div>
          </div>
          <el-table
            :data="filteredPosts"
            style="width: 100%"
            stripe
            border
            v-loading="loading"
          >
            <el-table-column label="封面" width="120">
              <template slot-scope="scope">
                <el-image
                  :src="scope.row.image"
                  :preview-src-list="[scope.row.image]"
                  style="width: 80px; height: 60px"
                  fit="cover"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column
              prop="title"
              label="标题"
              min-width="200"
            ></el-table-column>
            <el-table-column
              prop="date"
              label="发布时间"
              width="150"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="likes"
              label="点赞数"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="favorites"
              label="收藏数"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column label="状态" width="120" align="center">
              <template slot-scope="scope">
                <el-tag :type="statusType(scope.row.status)" effect="plain">
                  {{ statusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="220"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  @click="viewPost(scope.row)"
                >
                  查看
                </el-button>
                <!-- <el-button
                  size="mini"
                  type="warning"
                  @click="editPost(scope.row)"
                >
                  编辑
                </el-button> -->
                <el-button
                  size="mini"
                  type="danger"
                  @click="deletePost(scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-container">
            <el-pagination
              @size-change="handlePostSizeChange"
              @current-change="handlePostPageChange"
              :current-page="postQuery.page"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="postQuery.limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="postTotal"
            ></el-pagination>
          </div>
        </div>

        <!-- 我的商品 -->
        <div v-if="activeMenu === '3'">
          <el-table
            :data="products"
            style="width: 100%"
            stripe
            border
            v-loading="loading"
          >
            <!-- 产品图片 -->
            <el-table-column label="商品图片" width="120">
              <template slot-scope="scope">
                <el-image
                  :src="scope.row.image"
                  :preview-src-list="[scope.row.image]"
                  style="width: 60px; height: 60px"
                  fit="cover"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </template>
            </el-table-column>

            <!-- 产品名称 -->
            <el-table-column
              prop="name"
              label="商品名称"
              width="200"
            ></el-table-column>

            <!-- 价格 -->
            <el-table-column
              prop="price"
              label="价格"
              width="120"
              align="center"
            >
              <template slot-scope="scope">
                ￥{{ scope.row.price.toFixed(2) }}
              </template>
            </el-table-column>
            <!-- 状态 -->
            <el-table-column
              prop="status"
              label="状态"
              width="100"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.status === 1 ? 'success' : 'danger'"
                  effect="plain"
                >
                  {{ scope.row.status === 1 ? "在售" : "已下架" }}
                </el-tag>
              </template>
            </el-table-column>

            <!-- 操作 -->
            <el-table-column
              label="操作"
              width="200"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  @click="offShelf(scope.row)"
                  v-if="scope.row.status === 1"
                >
                  下架
                </el-button>
                <el-button
                  size="mini"
                  type="success"
                  @click="onShelf(scope.row)"
                  v-else
                >
                  上架
                </el-button>
                <el-button
                  size="mini"
                  type="primary"
                  @click="viewProduct(scope.row)"
                >
                  查看
                </el-button>
                <el-button size="mini" @click="editProduct(scope.row)">
                  编辑
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-container">
            <el-pagination
              @size-change="handleProductSizeChange"
              @current-change="handleProductPageChange"
              :current-page="productQuery.page"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="productQuery.limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="productTotal"
            ></el-pagination>
          </div>
        </div>

        <!-- 我的点赞 -->
        <div v-if="activeMenu === '4'">
          <el-table
            :data="likedPosts"
            style="width: 100%"
            stripe
            border
            v-loading="loading"
          >
            <el-table-column label="帖子图片" width="120">
              <template slot-scope="scope">
                <el-image
                  :src="scope.row.image"
                  :preview-src-list="[scope.row.image]"
                  style="width: 80px; height: 60px"
                  fit="cover"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column
              prop="title"
              label="标题"
              min-width="200"
            ></el-table-column>
            <el-table-column
              prop="author"
              label="作者"
              width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="date"
              label="发布时间"
              width="150"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="likes"
              label="点赞数"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="favorites"
              label="收藏数"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              label="操作"
              width="150"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  @click="cancelLike(scope.row)"
                >
                  取消点赞
                </el-button>
                <el-button
                  size="mini"
                  type="primary"
                  @click="viewPost(scope.row)"
                >
                  查看
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-container">
            <el-pagination
              @size-change="handleLikeSizeChange"
              @current-change="handleLikePageChange"
              :current-page="likeQuery.page"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="likeQuery.limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="likeTotal"
            ></el-pagination>
          </div>
        </div>

        <!-- 我的收藏 -->
        <div v-if="activeMenu === '5'">
          <el-table
            :data="favoritePosts"
            style="width: 100%"
            stripe
            border
            v-loading="loading"
          >
            <el-table-column label="帖子图片" width="120">
              <template slot-scope="scope">
                <el-image
                  :src="scope.row.image"
                  :preview-src-list="[scope.row.image]"
                  style="width: 80px; height: 60px"
                  fit="cover"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column
              prop="title"
              label="标题"
              min-width="200"
            ></el-table-column>
            <el-table-column
              prop="author"
              label="作者"
              width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="date"
              label="发布时间"
              width="150"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="likes"
              label="点赞数"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="favorites"
              label="收藏数"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              label="操作"
              width="150"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  @click="cancelFavorite(scope.row)"
                >
                  取消收藏
                </el-button>
                <el-button
                  size="mini"
                  type="primary"
                  @click="viewPost(scope.row)"
                >
                  查看
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-container">
            <el-pagination
              @size-change="handleFavoriteSizeChange"
              @current-change="handleFavoritePageChange"
              :current-page="favoriteQuery.page"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="favoriteQuery.limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="favoriteTotal"
            ></el-pagination>
          </div>
        </div>

        <!-- 我的评论 -->
        <div v-if="activeMenu === '6'">
          <div class="filter-container">
            <el-tabs
              v-model="commentActiveTab"
              @tab-click="handleCommentTabClick"
            >
              <el-tab-pane label="全部" name="all"></el-tab-pane>
              <el-tab-pane label="被举报" name="reported"></el-tab-pane>
            </el-tabs>
          </div>
          <el-table
            :data="comments"
            style="width: 100%"
            stripe
            border
            v-loading="loading"
          >
            <el-table-column
              prop="content"
              label="评论内容"
              min-width="200"
            ></el-table-column>
            <el-table-column
              prop="postTitle"
              label="所属帖子"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="likes"
              label="点赞数"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="replies"
              label="回复数"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="date"
              label="发布时间"
              width="150"
              align="center"
            ></el-table-column>
            <el-table-column
              label="操作"
              width="150"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  @click="showCommentDetail(scope.row)"
                >
                  查看
                </el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="deleteComment(scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-container">
            <el-pagination
              @size-change="handleCommentSizeChange"
              @current-change="handleCommentPageChange"
              :current-page="commentQuery.page"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="commentQuery.limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="commentTotal"
            ></el-pagination>
          </div>
        </div>

        <!-- 关注/粉丝 -->
        <div v-if="activeMenu === '7'">
          <div class="filter-container">
            <el-tabs
              v-model="followActiveTab"
              @tab-click="handleFollowTabClick"
            >
              <el-tab-pane label="粉丝" name="fans"></el-tab-pane>
              <el-tab-pane label="已关注" name="following"></el-tab-pane>
            </el-tabs>
          </div>
          <el-table
            :data="followList"
            style="width: 100%"
            stripe
            border
            v-loading="loading"
          >
            <el-table-column label="头像" width="100">
              <template slot-scope="scope">
                <el-avatar :size="50" :src="scope.row.avatar"></el-avatar>
              </template>
            </el-table-column>
            <el-table-column
              prop="username"
              label="用户名"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="followTime"
              label="关注时间"
              width="150"
              align="center"
            ></el-table-column>
            <el-table-column
              label="操作"
              width="150"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  @click="viewUser(scope.row)"
                  v-if="followActiveTab === 'fans'"
                >
                  回关
                </el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="unfollow(scope.row)"
                  v-else
                >
                  取消关注
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-container">
            <el-pagination
              @size-change="handleFollowSizeChange"
              @current-change="handleFollowPageChange"
              :current-page="followQuery.page"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="followQuery.limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="followTotal"
            ></el-pagination>
          </div>
        </div>

        <!-- 私信列表 -->
        <div v-if="activeMenu === '8'">
          <el-row>
            <el-col :span="24">
              <div class="chat-list">
                <!-- 搜索框 -->
                <div class="chat-search">
                  <el-input
                    placeholder="搜索"
                    prefix-icon="el-icon-search"
                    class="search-input"
                  >
                  </el-input>
                </div>

                <!-- 聊天列表 -->
                <div class="chat-items">
                  <div
                    v-for="(item, index) in chatList"
                    :key="index"
                    class="chat-item"
                    :class="{ active: currentChat === item.id }"
                    @click="selectChat(item.id)"
                  >
                    <!-- 头像 -->
                    <div class="avatar">
                      <el-avatar :size="48" :src="item.avatar"></el-avatar>
                      <span v-if="item.unread > 0" class="badge">{{
                        item.unread
                      }}</span>
                    </div>

                    <!-- 内容 -->
                    <div class="content"
                         @click="goChat(item.id)">
                      <div class="header">
                        <span class="username">{{ item.name }}</span>
                        <span class="time">{{ item.time }}</span>
                      </div>
                      <div class="preview">
                        <span class="text">{{ item.lastMsg }}</span>
                        <span v-if="item.muted" class="muted-icon">
                          <i class="el-icon-turn-off-microphone"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-main>

      <el-dialog
        title="编辑商品"
        :visible.sync="productDialogVisible"
        width="70%"
        @close="resetProductForm"
      >
        <el-form :model="productForm" label-width="100px" ref="productForm">
          <el-form-item label="商品名称" prop="name">
            <el-input v-model="productForm.name"></el-input>
          </el-form-item>
          <el-form-item label="商品价格" prop="price">
            <el-input-number
              v-model="productForm.price"
              :min="0"
              :precision="2"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="商品描述" prop="description">
            <el-input
              type="textarea"
              v-model="productForm.description"
              rows="3"
            ></el-input>
          </el-form-item>
          <el-form-item label="商品图片">
            <el-upload
              action="http://www.wjyzlj.cn/pet/file/upload"
              list-type="picture-card"
              :file-list="productForm.imageList"
              :on-success="handleProductImageSuccess"
              :on-remove="handleProductImageRemove"
              :headers="headers"
              multiple
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="productDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveProduct">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 评论详情弹窗 -->
      <el-dialog
        title="评论详情"
        :visible.sync="commentDetailVisible"
        width="50%"
      >
        <div v-if="currentComment" class="comment-detail">
          <div class="comment-header">
            <el-avatar :size="50" :src="currentComment.avatar"></el-avatar>
            <div class="user-info">
              <span class="username">{{ currentComment.username }}</span>
              <span class="time">{{ currentComment.date }}</span>
            </div>
          </div>
          <div class="comment-content">
            <p>{{ currentComment.content }}</p>
          </div>
          <div class="comment-stats">
            <span
              ><i class="el-icon-thumb"></i> {{ currentComment.likes }} 赞</span
            >
            <span
              ><i class="el-icon-chat-dot-round"></i>
              {{ currentComment.replies }} 回复</span
            >
          </div>
          <div class="comment-post" v-if="currentComment.postTitle">
            <p>所属帖子: {{ currentComment.postTitle }}</p>
          </div>
          <div class="comment-reports" v-if="currentComment.reported">
            <el-alert title="该评论已被举报" type="warning" :closable="false">
              <div v-if="currentComment.reportReason">
                <p>举报原因: {{ currentComment.reportReason }}</p>
              </div>
            </el-alert>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="commentDetailVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
    </el-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "UserInfo",
  data() {
    return {
      productDialogVisible: false, // 商品编辑弹窗显示状态
      productForm: {
        // 商品表单数据
        id: null,
        name: "",
        price: 0,
        description: "",
        imageList: [],
      },
      commentDetailVisible: false, // 评论详情弹窗显示状态
      currentComment: null, // 当前查看的评论
      currentChat: null,
      activeMenu: "1", // 当前选中的菜单项
      headers: { Authorization: sessionStorage.getItem("token") }, //存储token
      passwordDialogVisible: false,
      passwordForm: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      passwordRules: {
        oldPassword: [
          { required: true, message: "请输入原密码", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur",
          },
        ],
        confirmPassword: [
          { required: true, message: "请确认新密码", trigger: "blur" },
          { validator: this.validateConfirmPassword, trigger: "blur" },
        ],
      },
      // 帖子相关
      postActiveTab: "all",
      postQuery: {
        page: 1,
        limit: 10,
        status: null,
      },
      postTotal: 0,
      // 商品相关
      productQuery: {
        page: 1,
        limit: 10,
      },
      productTotal: 0,
      // 点赞相关
      likeQuery: {
        page: 1,
        limit: 10,
      },
      likeTotal: 0,
      likedPosts: [],
      // 收藏相关
      favoriteQuery: {
        page: 1,
        limit: 10,
      },
      favoriteTotal: 0,
      favoritePosts: [],
      // 评论相关
      commentActiveTab: "all",
      commentQuery: {
        page: 1,
        limit: 10,
        reported: false,
      },
      commentTotal: 0,
      comments: [],
      // 关注/粉丝相关
      followActiveTab: "fans",
      followQuery: {
        page: 1,
        limit: 10,
        type: "fans",
      },
      followTotal: 0,
      followList: [],

      userInfo: {
        headPicture: "",
        username: "",
        sex: 0,
        createTime: "",
        email: "",
        phone: "",
        introduction: "",
        imgUrl: "",
        followCount: 0,
        fansCount: 0,
      },
      chatList: [
        {
          id: 1,
          name: "test",
          avatar: "https://dummyimage.com/50x50/4CAF50/fff&text=G",
          lastMsg: "这是一条测试消息...",
          time: "09:30",
          unread: 3,
          muted: true,
        },
        {
          id: 2,
          name: "test2",
          avatar: "https://dummyimage.com/50x50/2196F3/fff&text=Z",
          lastMsg: "这是一条测试消息",
          time: "昨天",
          unread: 0,
        },
        {
          id: 3,
          name: "test3",
          avatar: "https://dummyimage.com/50x50/FF9800/fff&text=P",
          lastMsg: "这是一条测试消息...",
          time: "周三",
          unread: 12,
        },
      ],
      posts: [
        {
          id: 1,
          title: "帖子1",
          date: "2023-10-01",
          image: "https://via.placeholder.com/150",
          likes: 10,
          favorites: 5,
          status: 1,
          author: "用户A",
        },
        {
          id: 2,
          title: "帖子2",
          date: "2023-10-02",
          image: "https://via.placeholder.com/150",
          likes: 20,
          favorites: 8,
          status: 2,
          author: "用户B",
        },
        {
          id: 3,
          title: "帖子3",
          date: "2023-10-03",
          image: "https://via.placeholder.com/150",
          likes: 15,
          favorites: 3,
          status: 3,
          author: "用户C",
        },
      ],
      postFilterDate: null,
      filteredPosts: [],
      products: [
        {
          id: 1,
          name: "皇家狗粮",
          image: "https://dummyimage.com/200x200/4CAF50/fff",
          price: 99.99,
          stock: 150,
          status: 1,
        },
        {
          id: 2,
          name: "猫猫罐头",
          image: "https://dummyimage.com/200x200/2196F3/fff",
          price: 29.0,
          stock: 0,
          status: 0,
        },
      ],
      loading: false,
    };
  },
  created() {
    this.filteredPosts = this.posts; // 初始化帖子列表
    this.likedPosts = this.posts.slice(); // 初始化点赞列表
    this.favoritePosts = this.posts.slice(); // 初始化收藏列表
    this.comments = [
      {
        id: 1,
        content: "这个帖子很有帮助！",
        postTitle: "宠物护理指南",
        likes: 5,
        replies: 2,
        date: "2023-07-25",
        reported: false,
      },
      {
        id: 2,
        content: "我觉得有些地方不太对",
        postTitle: "猫咪饮食注意事项",
        likes: 2,
        replies: 1,
        date: "2023-07-24",
        reported: true,
      },
    ];
    this.followList = [
      {
        id: 1,
        username: "用户A",
        avatar: "https://dummyimage.com/50x50/4CAF50/fff",
        followTime: "2023-07-20",
      },
      {
        id: 2,
        username: "用户B",
        avatar: "https://dummyimage.com/50x50/2196F3/fff",
        followTime: "2023-07-15",
      },
    ];
    this.postTotal = this.posts.length;
    this.productTotal = this.products.length;
    this.likeTotal = this.likedPosts.length;
    this.favoriteTotal = this.favoritePosts.length;
    this.commentTotal = this.comments.length;
    this.followTotal = this.followList.length;
  },
  mounted() {
    //加载个人信息
    this.getInfo();
  },
  methods: {
    // 修改密码相关方法
    showChangePasswordDialog() {
      this.passwordDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.passwordForm.resetFields();
      });
    },
    validateConfirmPassword(rule, value, callback) {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    },
    changePassword() {
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          // 这里添加修改密码的API调用
          this.$message.success("密码修改成功");
          this.passwordDialogVisible = false;
        }
      });
    },

    // 帖子相关方法
    handlePostTabClick(tab) {
      this.postQuery.page = 1;
      if (tab.name === "all") {
        this.postQuery.status = null;
      } else if (tab.name === "reviewing") {
        this.postQuery.status = 2;
      } else if (tab.name === "published") {
        this.postQuery.status = 1;
      } else if (tab.name === "rejected") {
        this.postQuery.status = 3;
      }
      this.getPosts();
    },
    handlePostSizeChange(val) {
      this.postQuery.limit = val;
      this.getPosts();
    },
    handlePostPageChange(val) {
      this.postQuery.page = val;
      this.getPosts();
    },
    getPosts() {
      // 这里添加获取帖子的API调用
      this.loading = true;
      // 模拟API调用
      setTimeout(() => {
        if (this.postQuery.status) {
          this.filteredPosts = this.posts.filter(
            (post) => post.status === this.postQuery.status
          );
        } else {
          this.filteredPosts = this.posts;
        }
        this.loading = false;
      }, 500);
    },
    refreshPosts() {
      this.getPosts();
    },

    // 商品相关方法
    handleProductSizeChange(val) {
      this.productQuery.limit = val;
      this.getProducts();
    },
    handleProductPageChange(val) {
      this.productQuery.page = val;
      this.getProducts();
    },
    // 商品编辑相关
    editProduct(product) {
      // 打开弹窗并初始化表单数据
      this.productDialogVisible = true;
      this.productForm = {
        id: product.id,
        name: product.name,
        price: product.price,
        description: product.description || "",
        imageList: (product.images || []).map((url) => ({
          url: url,
          status: "success",
        })),
      };
    },

    // 处理图片上传成功
    handleProductImageSuccess(res, file) {
      this.productForm.imageList.push({
        url: res.data,
        status: "success",
      });
    },

    // 处理图片删除
    handleProductImageRemove(file, fileList) {
      this.productForm.imageList = fileList;
    },

    // 保存商品信息
    saveProduct() {
      // 构造提交数据
      const formData = {
        id: this.productForm.id,
        name: this.productForm.name,
        price: this.productForm.price,
        description: this.productForm.description,
        images: this.productForm.imageList.map((item) => item.url),
      };

      // 调用更新商品API
      // axios.put("/api/products", formData)
      //   .then(() => {
      //     this.$message.success("商品更新成功");
      //     this.productDialogVisible = false;
      //     this.getProducts(); // 刷新商品列表
      //   })
      //   .catch(error => {
      //     console.error("更新商品失败:", error);
      //     this.$message.error("商品更新失败");
      //   });
    },

    // 重置商品表单
    resetProductForm() {
      this.productForm = {
        id: null,
        name: "",
        price: 0,
        description: "",
        imageList: [],
      };
    },

    // 新增方法 - 评论相关
    showCommentDetail(comment) {
      this.currentComment = comment;
      this.commentDetailVisible = true;
    },
    getProducts() {
      // 这里添加获取商品的API调用
      this.loading = true;
      // 模拟API调用
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },

    // 点赞相关方法
    handleLikeSizeChange(val) {
      this.likeQuery.limit = val;
      this.getLikedPosts();
    },
    handleLikePageChange(val) {
      this.likeQuery.page = val;
      this.getLikedPosts();
    },
    getLikedPosts() {
      // 这里添加获取点赞帖子的API调用
      this.loading = true;
      // 模拟API调用
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    cancelLike(post) {
      this.$confirm("确定要取消点赞吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.likedPosts = this.likedPosts.filter((item) => item.id !== post.id);
        this.likeTotal--;
        this.$message.success("已取消点赞");
      });
    },

    // 收藏相关方法
    handleFavoriteSizeChange(val) {
      this.favoriteQuery.limit = val;
      this.getFavoritePosts();
    },
    handleFavoritePageChange(val) {
      this.favoriteQuery.page = val;
      this.getFavoritePosts();
    },
    getFavoritePosts() {
      // 这里添加获取收藏帖子的API调用
      this.loading = true;
      // 模拟API调用
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    cancelFavorite(post) {
      this.$confirm("确定要取消收藏吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.favoritePosts = this.favoritePosts.filter(
          (item) => item.id !== post.id
        );
        this.favoriteTotal--;
        this.$message.success("已取消收藏");
      });
    },

    // 评论相关方法
    handleCommentTabClick(tab) {
      this.commentQuery.page = 1;
      this.commentQuery.reported = tab.name === "reported";
      this.getComments();
    },
    handleCommentSizeChange(val) {
      this.commentQuery.limit = val;
      this.getComments();
    },
    handleCommentPageChange(val) {
      this.commentQuery.page = val;
      this.getComments();
    },
    getComments() {
      // 这里添加获取评论的API调用
      this.loading = true;
      // 模拟API调用
      setTimeout(() => {
        if (this.commentQuery.reported) {
          this.comments = this.comments.filter((comment) => comment.reported);
        } else {
          this.comments = this.comments;
        }
        this.loading = false;
      }, 500);
    },
    viewComment(comment) {
      this.$message(`查看评论: ${comment.content}`);
    },
    deleteComment(comment) {
      this.$confirm("确定要删除该评论吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.comments = this.comments.filter((item) => item.id !== comment.id);
        this.commentTotal--;
        this.$message.success("评论已删除");
      });
    },

    // 关注/粉丝相关方法
    handleFollowTabClick(tab) {
      this.followQuery.page = 1;
      this.followQuery.type = tab.name;
      this.getFollowList();
    },
    handleFollowSizeChange(val) {
      this.followQuery.limit = val;
      this.getFollowList();
    },
    handleFollowPageChange(val) {
      this.followQuery.page = val;
      this.getFollowList();
    },
    getFollowList() {
      // 这里添加获取关注/粉丝列表的API调用
      this.loading = true;
      // 模拟API调用
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    viewUser(user) {
      this.followList = this.followList.filter((item) => item.id !== user.id);
      this.followTotal--;
      this.$message(`查看用户: ${user.username}`);
    },
    unfollow(user) {
      this.$confirm(`确定要取消关注 ${user.username} 吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.followList = this.followList.filter((item) => item.id !== user.id);
        this.followTotal--;
        this.$message.success("已取消关注");
      });
    },

    offShelf(product) {
      this.$confirm("确定要下架该商品吗？", "提示", {
        type: "warning",
      }).then(() => {
        product.status = 0;
        this.$message.success("商品已下架");
      });
    },
    onShelf(product) {
      product.status = 1;
      this.$message.success("商品已上架");
    },
    // 查看详情逻辑
    viewProduct(product) {
      console.log("查看商品:", product);
      this.$router.push('/detailGoodsPage')
    },
    // 切换到不同菜单时加载对应数据
    handleMenuSelect(index) {
      this.activeMenu = index;
      switch (index) {
        case "1":
          this.getInfo();
          break;
        case "2":
          this.getPosts();
          break;
        case "3":
          this.getProducts();
          break;
        case "4":
          this.getLikedPosts();
          break;
        case "5":
          this.getFavoritePosts();
          break;
        case "6":
          this.getComments();
          break;
        case "7":
          this.getFollowList();
          break;
        case "8":
          // 加载私信列表
          break;
      }
    },
    // 状态类型映射
    statusType(status) {
      const typeMap = {
        1: "success",
        2: "warning",
        3: "danger",
      };
      return typeMap[status] || "info";
    },

    // 状态文本映射
    statusText(status) {
      const textMap = {
        1: "已发布",
        2: "审核中",
        3: "已驳回",
      };
      return textMap[status] || "未知状态";
    },

    // 删除帖子
    deletePost(post) {
      this.$confirm("确定要永久删除该帖子吗？", "警告", {
        type: "warning",
        confirmButtonText: "确认删除",
        cancelButtonText: "取消",
        confirmButtonClass: "el-button--danger",
      }).then(() => {
        this.filteredPosts = this.filteredPosts.filter(
          (item) => item.id !== post.id
        );
        this.postTotal--;
        this.$message.success("帖子已删除");
      });
    },

    // 查看帖子
    viewPost(post) {
      console.log("查看帖子:", post);
      // 这里添加查看逻辑
      this.$router.push('/detailComPage')
    },

    // 编辑帖子
    editPost(post) {
      console.log("编辑帖子:", post);
      // 这里添加编辑逻辑
    },

    // 日期筛选
    filterPostsByDate() {
      // 保持原有筛选逻辑
      console.log("按日期筛选:", this.postFilterDate);
    },
    //上传成功的回调
    handleAvatarSuccess(res, file) {
      this.userInfo.imgUrl = res.data;
      this.userInfo.headPicture = res.data;
      this.userInfo.avatar = URL.createObjectURL(file.raw);
    },
    //保存修改用户信息
    saveUserInfo() {
      //获取token并设置请求头
      const token = sessionStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `${token}`;

      axios
        .put("http://www.wjyzlj.cn/pet/user", this.userInfo)
        .then((response) => {
          if (response.data.data) {
            this.$message.success("修改成功");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message.error("修改失败");
        });
    },
    //发送请求获取个人信息
    getInfo() {
      //获取登录时 存在cookie的用户id
      const currentId = this.getCookie("id");
      //获取token并设置请求头
      const token = sessionStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `${token}`;

      axios
        .get(`http://www.wjyzlj.cn/pet/user/${currentId}`)
        .then((response) => {
          this.userInfo = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCookie(name) {
      // 获取所有cookie字符串
      let cookies = document.cookie.split(";");
      // 遍历每个cookie
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim(); // 去除空格
        if (cookie.startsWith(name + "=")) {
          return cookie.substring(name.length + 1); // 返回cookie值
        }
      }

      return null; // 如果没有找到指定的cookie，返回null
    },
    //跳转聊天页面
    goChat(userID){
      this.$router.push('/mesPage')
    }
  },
};
</script>

<style scoped>
.comment-detail {
  padding: 20px;
}

.comment-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.user-info {
  margin-left: 15px;
}

.username {
  font-weight: bold;
  display: block;
}

.time {
  color: #999;
  font-size: 12px;
}

.comment-content {
  margin-bottom: 20px;
  padding: 15px;
  background: #f8f8f8;
  border-radius: 4px;
}

.comment-stats {
  margin-bottom: 15px;
}

.comment-stats span {
  margin-right: 20px;
  color: #666;
}

.comment-reports {
  margin-top: 20px;
}

/* 商品图片上传样式 */
.el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh;
}

.el-container {
  height: 100%;
}

.el-aside {
  background-color: #fff;
  border-right: 1px solid #e6e6e6;
}

.el-menu {
  border-right: none;
}

.el-main {
  padding: 20px;
  background-color: #f5f7fa;
}

/* 头像上传样式 */
.avatar-upload-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
  margin-bottom: 15px;
}

.avatar-uploader:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
  border-radius: 50%;
}

.follow-info {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
}

.follow-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 15px;
  cursor: pointer;
}

.follow-item .count {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.follow-item .label {
  font-size: 14px;
  color: #666;
}

/* 过滤容器样式 */
.filter-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.filter-bar {
  display: flex;
  align-items: center;
}

/* 分页样式 */
.pagination-container {
  margin-top: 20px;
  text-align: right;
}

/* 表格样式 */
.el-table {
  margin-top: 20px;
}

/* 图片错误样式 */
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 24px;
}

/* 聊天列表样式 */
.chat-list {
  height: 100vh;
  background: #f5f5f5;
}

.chat-search {
  padding: 15px;
  background: #fff;
  border-bottom: 1px solid #e7e7e7;
}

.search-input {
  /deep/ .el-input__inner {
    border-radius: 15px;
  }
}

.chat-items {
  height: calc(100vh - 60px);
  overflow-y: auto;
}

.chat-item {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background 0.3s;
}

.chat-item:hover {
  background: #f5f5f5;
}

.chat-item.active {
  background: #e6f7ff;
}

.avatar {
  position: relative;
  margin-right: 15px;
}

.badge {
  position: absolute;
  top: -5px;
  right: -5px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  background: #f56c6c;
  color: white;
  border-radius: 9px;
  font-size: 12px;
  text-align: center;
  line-height: 18px;
}

.content {
  flex: 1;
  min-width: 0;
}

.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}

.username {
  font-weight: 500;
  font-size: 14px;
  color: #333;
}

.time {
  font-size: 12px;
  color: #999;
}

.preview {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.text {
  font-size: 12px;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}

.muted-icon {
  color: #999;
  margin-left: 8px;
  font-size: 14px;
}

/* 滚动条样式 */
.chat-items::-webkit-scrollbar {
  width: 6px;
}

.chat-items::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.chat-items::-webkit-scrollbar-track {
  background: transparent;
}
</style>